import { render, staticRenderFns } from "./stockMoveOneStepAction.vue?vue&type=template&id=5632ded9&scoped=true"
import script from "./stockMoveOneStepAction.vue?vue&type=script&lang=js"
export * from "./stockMoveOneStepAction.vue?vue&type=script&lang=js"
import style0 from "./stockMoveOneStepAction.vue?vue&type=style&index=0&id=5632ded9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5632ded9",
  null
  
)

export default component.exports